import styled from 'styled-components';

import colors from '../../../styles/colors';

export const Container = styled.div`
  display: flex;
`;

export const Text = styled.span`
  font-size: 12px;
  padding: 5px;
  color: ${colors.graysecondary};
`;
